import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ServiceTypeStoreEffects } from './effects';
import { serviceTypeReducer } from './reducer';
import { ServiceTypeFacade } from './facade';
import { stateName } from './selectors';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(stateName, serviceTypeReducer), EffectsModule.forFeature([ServiceTypeStoreEffects])],
  exports: [],
  providers: [ServiceTypeFacade],
  declarations: [],
})
export class ServiceTypeStateModule {}
